import http from "../axios/http-common";

class InterfacePemeriksaanFisikRalan {
  getPemeriksaanFisikRalan(unit, reg) {
    return http.getData(`/pemeriksaan-fisik-ralan/unit/${unit}/register/${reg}`);
  }

  savePemeriksaanFisikRalan(
    reg,
    unit_id,
    rm,
    param
  ) {
    return http.postData(`/pemeriksaan-fisik-ralan`, {
      register_id: reg,
      unit_id: unit_id,
      pasien_rm: rm,
     
      tanda_vital: {
        sistole: param['tanda_vital']['sistole'],
        diastole: param['tanda_vital']['diastole'],
        frekuensi_nadi: param['tanda_vital']['frekuensi_nadi'],
        frekuensi_nafas: param['tanda_vital']['frekuensi_nafas'],
        suhu_badan: param['tanda_vital']['suhu_badan'],
        saturasi_oksigen: param['tanda_vital']['saturasi_oksigen'],
        keadaan_umum: param['tanda_vital']['keadaan_umum'],
        kesadaran: param['tanda_vital']['kesadaran'],
      },
      antropometri: {
        berat_badan: param['antropometri']['berat_badan'],
        tinggi_badan: param['antropometri']['tinggi_badan'],
        lingkar_kepala: param['antropometri']['lingkar_kepala'],
        lla: param['antropometri']['lla'],
        imt: param['antropometri']['imt'],
      },
      nyeri: {
        skala: param['nyeri']['skala'],
        lokasi: param['nyeri']['lokasi'],
        // intensitas: param['nyeri']['intensitas'],
        durasi: param['nyeri']['durasi'],
        frekuensi: param['nyeri']['frekuensi'],
        pencetus: param['nyeri']['pencetus'],
        kualitas: param['nyeri']['kualitas'],
        pola_serangan: param['nyeri']['pola_serangan'],
        penyebab_hilang: param['nyeri']['penyebab_hilang'],
        jenis: param['nyeri']['jenis'],
      }
    });
  }

  editPemeriksaanFisikRalan(
    reg,
    unit_id,
    rm,
    param
  ) {
    return http.putData(`/pemeriksaan-fisik-ralan`, {
      register_id: reg,
      unit_id: unit_id,
      pasien_rm: rm,
      
      tanda_vital: {
        id: param['tanda_vital']['id'],
        sistole: param['tanda_vital']['sistole'],
        diastole: param['tanda_vital']['diastole'],
        frekuensi_nadi: param['tanda_vital']['frekuensi_nadi'],
        frekuensi_nafas: param['tanda_vital']['frekuensi_nafas'],
        suhu_badan: param['tanda_vital']['suhu_badan'],
        saturasi_oksigen: param['tanda_vital']['saturasi_oksigen'],
        keadaan_umum: param['tanda_vital']['keadaan_umum'],
        kesadaran: param['tanda_vital']['kesadaran'],
      },
      antropometri: {
        id: param['antropometri']['id'],
        berat_badan: param['antropometri']['berat_badan'],
        tinggi_badan: param['antropometri']['tinggi_badan'],
        lingkar_kepala: param['antropometri']['lingkar_kepala'],
        lla: param['antropometri']['lla'],
        imt: param['antropometri']['imt'],
      },
    
      nyeri: {
        id: param['nyeri']['id'],
        skala: param['nyeri']['skala'],
        lokasi: param['nyeri']['lokasi'],
        // intensitas: param['nyeri']['intensitas'],
        durasi: param['nyeri']['durasi'],
        frekuensi: param['nyeri']['frekuensi'],
        pencetus: param['nyeri']['pencetus'],
        kualitas: param['nyeri']['kualitas'],
        pola_serangan: param['nyeri']['pola_serangan'],
        penyebab_hilang: param['nyeri']['penyebab_hilang'],
        jenis: param['nyeri']['jenis'],
      }
    });
  }
}
export default new InterfacePemeriksaanFisikRalan();
